import { BefGlobalContext, BefRpcContext } from "@beflam/bef-core";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export function AppList() {

    const rpcService = useContext(BefRpcContext);
    const globalService = useContext(BefGlobalContext);
    const [apps, setApps] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetchAppList();
    }, []);

    async function fetchAppList() {
        const appList = await rpcService.callRpcAsync<[]>("", "Beflam.Framework", "Beflam.Framework.Service.ConfigService", "AppList", null);
        setApps(appList);
    };

    function redictToApp(appItem: any) {
        globalService.currentAppId = appItem.AppId;
        let extendUrl = window.location.search;
        navigate("/" + extendUrl);
    }

    return (
        <div style={{ marginTop: 100, marginLeft: 50, marginRight: 50, display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
            {apps.map((item: any) => {
                return <div style={{ height: 150, width: 280, display: "flex", flexDirection: "column", margin: 5, padding: 5, backgroundColor: "white" }} key={item.AppId}>
                    <div style={{ flex: 1 }}>
                        <div style={{ width: 250, display: "flex", flexDirection: "row" }} >
                            <div style={{ fontSize: 20, flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 250 }} >{item.AppName}</div>
                            {item.AppLogo ? <img alt='AppLogo' style={{ height: 25, width: 25, marginRight: 5 }} src={item.AppLogo} /> : <img alt="beflam.png" style={{ height: 25, width: 25, marginRight: 5 }} src='assets/img/beflam.png' />}
                        </div>
                        <div style={{ border: ".5px solid rgba(0, 0, 0, 0.1)", margin: 5 }} />
                        <div style={{ height: 30 }}>{item.AppId}</div>
                    </div>
                    <div style={{ border: ".5px solid rgba(0, 0, 0, 0.1)", margin: 5 }} />
                    <button key="action1" style={{ width: 50, marginTop: 5 }} onClick={() => redictToApp(item)}>
                        Access
                    </button>
                </div>
            })}
        </div>
    );
}